import { z as e } from "zod";
const h = (t) => typeof t == "object" ? t.toString() : t, a = e.preprocess((t) => t instanceof Date ? t : typeof t == "object" && t !== null && "seconds" in t && "nanoseconds" in t && typeof t.seconds == "number" ? new Date(t.seconds * 1e3) : new Date(t), e.date()), be = e.object({
  _id: e.preprocess(h, e.string()),
  listing_id: e.string().optional().nullable(),
  target_collection: e.string().optional().nullable(),
  flags: e.array(e.unknown()).optional().nullable(),
  content: e.unknown(),
  metadata: e.unknown(),
  created_at: a,
  updated_at: a.optional().nullable(),
  marked_done_at: a.optional().nullable(),
  done: e.coerce.boolean().optional().nullable(),
  activity: e.array(
    e.object({
      action: e.string(),
      timestamp: a,
      user: e.string()
    })
  ).optional()
}), f = e.record(e.string(), e.any()).optional().nullable(), _e = e.object({
  filter: f,
  offset: e.coerce.number().optional().nullable()
}), pe = e.object({
  _id: e.string(),
  content: e.record(e.string(), e.any()).optional().nullable(),
  metadata: e.record(e.string(), e.any()).optional().nullable(),
  user: e.string(),
  done: e.boolean()
}), y = e.object({
  version_id: e.string(),
  created_at: a,
  creator: e.string(),
  collection: e.string()
}), he = e.object({
  listing_id: e.string()
}), fe = e.array(y), ye = e.object({
  _id: e.string(),
  version_id: e.string(),
  listing_id: e.string(),
  content_hash: e.string(),
  created_at: a,
  creator: e.string(),
  trace: e.object({}),
  content: e.unknown(),
  metadata: e.unknown(),
  other: e.unknown()
}), Se = e.object({
  listingId: e.string(),
  collection: e.string(),
  versionId: e.string().optional().nullable()
}), je = e.object({
  filePath: e.string()
}), ke = e.object({
  fileContent: e.string()
}), xe = e.object({
  listingId: e.string(),
  commitMessage: e.string(),
  creator: e.string(),
  content: e.record(e.string(), e.unknown()),
  metadata: e.record(e.string(), e.unknown()),
  collection: e.string(),
  existingVersionId: e.string().optional().nullable()
}), ve = e.object({
  versionId: e.string()
}), S = e.object({
  language: e.enum(["en", "sv"]),
  display_name: e.string(),
  has_seen_quick_guide: e.boolean().optional(),
  should_reload: e.boolean().optional()
}), j = e.object({
  company_id: e.string(),
  created_at: a,
  email: e.string(),
  email_verified: e.boolean(),
  signup_token_id: e.string().nullable().optional(),
  search_history_active: e.boolean().nullable().optional(),
  data_roles: e.array(e.string()).default([])
}), De = e.object({
  email_verification_token: e.string().nullable().optional()
}), k = e.object({
  company_id: e.string(),
  name: e.string()
}), we = e.object({
  user_editable: S,
  user_readable: j,
  company: k
}), x = ["en", "sv"], Ie = e.object({
  token: e.string(),
  company_id: e.string(),
  created_at: a,
  access_roles: e.array(e.string()),
  email_domain: e.string().optional().nullable(),
  expires_at: a.optional().nullable(),
  language: e.enum(x),
  max_uses: e.number(),
  // Do not add default values here!
  used_by: e.array(e.string()),
  // Do not add default values here!
  require_email_verification: e.boolean().default(!0),
  search_history_active: e.boolean().default(!0)
}), Re = e.object({
  ok: e.literal(!1),
  error: e.object({
    code: e.enum([
      "internal-server-error",
      "token-expired",
      "invalid-token",
      "user-disabled",
      "email-not-verified"
    ])
  })
}), Pe = e.object({
  token: e.string(),
  email: e.string(),
  username: e.string(),
  password: e.string()
}), Be = e.object({
  ok: e.literal(!0)
}).or(
  e.object({
    ok: e.literal(!1),
    error: e.object({
      code: e.enum([
        "internal-server-error",
        "username-too-short",
        "password-too-short",
        "email-invalid",
        "email-occupied",
        "email-not-verified",
        "signup-token-invalid",
        "signup-token-exhausted",
        "signup-token-expired",
        "email-domain-mismatch"
      ]),
      message: e.string()
    })
  })
), qe = e.object({
  verification_link_base_url: e.string()
}), Fe = e.object({
  ok: e.literal(!0)
}).or(
  e.object({
    ok: e.literal(!1),
    error: e.object({
      code: e.enum(["internal-server-error", "email-already-verified", "token-not-found"])
    })
  })
), ze = e.object({
  verification_token: e.string()
}), Ee = e.object({
  ok: e.literal(!0)
}).or(
  e.object({
    ok: e.literal(!1),
    error: e.object({
      code: e.enum(["internal-server-error", "token-not-found"])
    })
  })
), v = e.object({
  width: e.coerce.number(),
  height: e.coerce.number()
}), D = e.object({
  type: e.literal("pdf"),
  pageProps: e.array(v)
}), w = e.object({
  type: e.literal("md"),
  lineCount: e.coerce.number()
}), Ve = e.union([D, w]), o = e.preprocess((t) => t instanceof Date ? t : typeof t == "object" && t !== null && "seconds" in t && "nanoseconds" in t && typeof t.seconds == "number" ? new Date(t.seconds * 1e3) : new Date(t), e.date()), n = e.enum([
  "default",
  "bg",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fi",
  "fr",
  "ga",
  "hr",
  "hu",
  "it",
  "lt",
  "lv",
  "mt",
  "nl",
  "pl",
  "pt",
  "ro",
  "sk",
  "sl",
  "sv"
]), He = e.enum([
  "svensk_forfattningssamling",
  "förarbete_proposition",
  "förarbete_sou",
  "tingsrätt",
  "hovrätt",
  "högsta_domstolen",
  "förvaltningsrätt",
  "lansrätt",
  "högsta_förvaltningsdomstolen",
  "marknads_domstolen",
  "marknads_överdomstolen",
  "patent_och_marknadsdomstolen",
  "patent_och_marknadsöverdomstolen",
  "arbets_domstolen",
  "patentbesvärsrätt",
  "skatteärttsnämnden",
  "migrationsdomstolen",
  "finansinpektionen_prospekt",
  "esma",
  "eba",
  "eiopa",
  "eu_regulation",
  "eu_implementing_regulation",
  "eu_delegated_regulation",
  "eu_directive",
  "eu_implementing_directive",
  "eu_delegated_directive",
  "eu_decision",
  "eu_implementing_decision",
  "eu_delegated_decision",
  "eu_act_proposal",
  "eu_case_law"
]), I = e.object({
  metadata_type: e.literal("bundle_relation"),
  fallback_label: e.record(n, e.string()).nullable(),
  bundle_id: e.string()
}), R = e.object({
  metadata_type: e.literal("label_relation"),
  label: e.record(n, e.string())
}), P = e.object({
  metadata_type: e.literal("document_relation"),
  fallback_label: e.record(n, e.string()).nullable(),
  document_id: e.string(),
  language: n.nullable(),
  file_position: e.lazy(() => r).nullable()
}), B = e.object({
  metadata_type: e.literal("file_relation"),
  fallback_label: e.record(n, e.string()).nullable(),
  file_id: e.string(),
  file_position: e.lazy(() => r).nullable()
}), s = e.union([
  I,
  P,
  B,
  R
]), q = e.object({
  metadata_type: e.literal("identifier"),
  prefix: e.record(n, e.string()).nullable(),
  value: e.string(),
  suffix: e.record(n, e.string()).nullable()
}), F = e.object({
  metadata_type: e.literal("text_value"),
  value: e.record(n, e.string())
}), z = e.object({
  metadata_type: e.literal("long_text"),
  value: e.record(n, e.string())
}), E = e.object({
  metadata_type: e.literal("number"),
  value: e.number()
}), V = e.object({
  metadata_type: e.literal("boolean"),
  value: e.boolean()
}), H = e.object({
  metadata_type: e.literal("date"),
  year: e.number().nullable(),
  month: e.number().nullable(),
  day: e.number().nullable()
}), L = e.object({
  metadata_type: e.literal("link"),
  caption: e.record(n, e.string()),
  url: e.record(n, e.string())
}), T = e.object({
  metadata_type: e.literal("list"),
  items: e.array(e.lazy(() => c))
}), C = e.object({
  metadata_type: e.literal("dict"),
  items: e.record(
    e.string(),
    e.lazy(() => l)
  )
}), O = e.object({
  metadata_type: e.literal("status"),
  status: e.record(n, e.string())
}), N = e.object({
  metadata_type: e.literal("null"),
  metadata_target_type: e.enum([
    "list",
    "link",
    "date",
    "boolean",
    "number",
    "long_text",
    "text_value",
    "identifier",
    "relation",
    "bundle_relation",
    "document_relation",
    "dict"
  ]).nullable(),
  comment: e.string().nullable()
}), c = e.union([
  q,
  F,
  z,
  E,
  V,
  H,
  L,
  O,
  s,
  N,
  T,
  C
]), l = e.object({
  label: e.record(n, e.string()),
  hidden: e.boolean(),
  entry: c,
  order: e.number()
}), i = e.record(e.string(), l), Q = e.object({
  position_type: e.literal("md_tag"),
  reference_ids: e.array(e.string())
}), G = e.object({
  line_index: e.number().int(),
  start_char: e.number().int().nullable(),
  stop_char: e.number().int().nullable()
}), d = e.object({
  position_type: e.literal("md_line"),
  lines: e.array(G)
}), M = e.object({
  x0: e.number(),
  x1: e.number(),
  y0: e.number(),
  y1: e.number()
}), m = e.object({
  position_type: e.literal("bounding_box"),
  page_index: e.number().int(),
  bounding_boxes: e.array(M)
}), U = e.object({
  position_type: e.literal("offset"),
  page_index: e.number().int(),
  offset: e.number()
}), $ = e.union([Q, d]), A = e.union([m, U]), r = e.union([$, A]), J = e.object({
  node_index: e.number().int(),
  child_index: e.number().int(),
  depth_index: e.number().int(),
  parent_index: e.number().int().nullable(),
  children_indices: e.array(e.number().int()),
  label: e.string(),
  metadata: i,
  file_position: r
}), K = e.object({
  fragment_type: e.literal("metadata"),
  position: r,
  metadata: i
}), W = e.object({
  fragment_type: e.literal("mention"),
  position: r,
  relation: s
}), X = e.union([K, W]), Y = e.enum([
  "pdf",
  // Adobe Portable Document Format
  "doc",
  // Microsoft Word Document (Legacy)
  "docx",
  // Microsoft Word Document
  "txt",
  // Plain Text
  "rtf",
  // Rich Text Format
  "odt",
  // OpenDocument Text
  "md",
  // Markdown
  "xls",
  // Microsoft Excel Spreadsheet (Legacy)
  "xlsx",
  // Microsoft Excel Spreadsheet
  "csv",
  // Comma Separated Values
  "ods",
  // OpenDocument Spreadsheet
  "ppt",
  // Microsoft PowerPoint (Legacy)
  "pptx",
  // Microsoft PowerPoint
  "odp",
  // OpenDocument Presentation
  "jpg",
  // JPEG Image
  "jpeg",
  // JPEG Image
  "png",
  // Portable Network Graphics
  "gif",
  // Graphics Interchange Format
  "bmp",
  // Bitmap Image
  "tiff",
  // Tagged Image File Format
  "svg",
  // Scalable Vector Graphics
  "zip",
  // ZIP Archive
  "rar",
  // RAR Archive
  "tar",
  // Tape Archive
  "gz",
  // Gzip Compressed Archive
  "7z"
  // 7-Zip Archive
]), u = e.object({
  file_id: e.string(),
  file_hash: e.string(),
  file_format: Y,
  file_url: e.string().url(),
  label: e.string().nullable(),
  order: e.number()
}), Z = u.extend({
  language: n.nullable()
}), g = u.extend({
  language: n,
  is_readable: e.literal(!0),
  fragments: e.array(X),
  toc: e.array(J),
  cross_bundle_searchable: e.boolean()
}), ee = g.extend({
  file_format: e.literal("md"),
  line_count: e.number().int(),
  line_byte_indices: e.array(e.number().int()),
  lexical_json_url: e.string().url()
}), te = e.object({
  width: e.number(),
  height: e.number()
}), ne = g.extend({
  file_format: e.literal("pdf"),
  page_numbers: e.array(e.number().int()),
  page_props: e.array(te),
  page_count: e.number().int(),
  average_font_size: e.number().int().nullable().optional()
}), b = e.union([ee, ne]), ae = e.union([b, Z]), _ = e.object({
  document_id: e.string(),
  document_hash: e.string(),
  access_groups: e.array(e.string()),
  label: e.record(n, e.string()).nullable().default(null),
  names: e.record(n, e.array(e.string())),
  titles: e.record(n, e.array(e.string())),
  metadata: i,
  product_version_ids: e.array(e.string()),
  first_seen_at: o,
  last_seen_at: o,
  update_at: o,
  order: e.number()
}), oe = _.extend({
  files: e.array(b)
}), re = _.extend({
  files: e.array(ae)
}), Le = e.object({
  bundle_id: e.string(),
  bundle_hash: e.string(),
  access_groups: e.array(e.string()),
  names: e.record(n, e.array(e.string())),
  titles: e.record(n, e.array(e.string())),
  metadata: i,
  documents: e.array(oe),
  annexes: e.array(re),
  product_version_ids: e.array(e.string()),
  first_seen_at: o,
  last_seen_at: o,
  update_at: o
}), p = e.object({
  filter_id: e.string(),
  filter_mode: e.enum(["include", "exclude", "require"])
}), Te = e.object({
  query: e.string(),
  filter_selections: p.array()
}), Ce = e.object({
  cross_bundle_search_id: e.string()
}), Oe = e.object({
  query: e.string(),
  bundle_id: e.string()
}), Ne = e.object({
  in_bundle_search_id: e.string()
}), ie = e.object({
  bundle_pk: e.string(),
  score: e.number(),
  document_ids: e.array(e.string()).optional().nullable().default([])
}), Qe = e.object({
  cross_bundle_search_id: e.string(),
  processing_state: e.enum(["pending", "processing", "completed", "failed"]),
  query: e.string(),
  hits: e.array(ie),
  filter_selections: p.array(),
  created_at: a,
  updated_at: a,
  user_id: e.string(),
  hidden: e.boolean().default(!1),
  visited_bundles: e.array(e.string()).default([])
}), se = e.object({
  highlight_format: e.literal("pdf"),
  highlight_type: e.enum(["text", "keyword"]),
  position: m.array()
}), ce = e.object({
  highlight_format: e.literal("md"),
  highlight_type: e.enum(["text", "keyword"]),
  position: d.array()
}), le = e.discriminatedUnion("highlight_format", [
  se,
  ce
]), de = e.object({
  highlight: le,
  score: e.number()
}), me = e.object({
  document_pk: e.string(),
  file_pk: e.string(),
  block_hits: e.array(de),
  score: e.number()
}), Ge = e.object({
  in_bundle_search_id: e.string(),
  processing_state: e.enum(["pending", "processing", "completed", "failed"]),
  query: e.string(),
  bundle_pk: e.string(),
  hits: e.array(me),
  created_at: a,
  updated_at: a
}), Me = e.object({
  query: e.string(),
  access_groups: e.array(e.string()),
  categories: e.array(e.string()),
  filters: e.array(e.string()),
  active: e.boolean()
}), Ue = e.object({
  filterId: e.string(),
  label: e.string(),
  access_groups: e.array(e.string()),
  categories: e.array(e.string()),
  filters: e.array(e.string()),
  active: e.boolean()
}), ue = e.object({
  id: e.string(),
  label: e.record(n, e.string()),
  order: e.number()
}), $e = e.object({
  tag: e.string(),
  access_groups: e.array(e.string()),
  count: e.number(),
  path: e.array(ue)
});
export {
  re as annexSchema,
  Re as authenticationErrorResponseSchema,
  _ as baseDocumentSchema,
  u as baseFileSchema,
  de as blockHitSchema,
  M as boundingBoxSchema,
  ie as bundleHitSchema,
  Le as bundleSchema,
  xe as commitDocumentInputSchema,
  ve as commitDocumentResponseSchema,
  k as companySchema,
  Qe as crossBundleSearchDocumentSchema,
  Te as crossBundleSearchInputSchema,
  Ce as crossBundleSearchOutputSchema,
  o as dateSchema,
  $e as documentGroupCountSchema,
  me as documentHitSchema,
  Ve as documentPropsSchema,
  oe as documentSchema,
  He as documentTagsSchema,
  y as documentVersionSchema,
  je as downloadDocumentInputSchema,
  ke as downloadDocumentResponseSchema,
  Me as exampleQuerySchema,
  _e as fetchQueueDocumentInputSchema,
  Y as fileFormatSchema,
  r as filePositionSchema,
  ae as fileSchema,
  p as filterSelectionSchema,
  Se as getDocumentByIdInputSchema,
  he as getDocumentVersionsInputSchema,
  fe as getDocumentVersionsResponseSchema,
  le as highlightSchema,
  Ge as inBundleSearchDocumentSchema,
  Oe as inBundleSearchInputSchema,
  Ne as inBundleSearchOutputSchema,
  n as langSchema,
  x as languages,
  w as mdDocumentPropsSchema,
  ee as mdFileSchema,
  ce as mdHighlightSchema,
  d as mdLinePositionSchema,
  G as mdLineRangePositionSchema,
  $ as mdPositionSchema,
  Q as mdTaggedPositionSchema,
  V as metadataBooleanSchema,
  I as metadataBundleRelationSchema,
  l as metadataContainerSchema,
  H as metadataDateSchema,
  C as metadataDictSchema,
  P as metadataDocumentRelationSchema,
  c as metadataEntrySchema,
  B as metadataFileRelationSchema,
  K as metadataFragmentSchema,
  q as metadataIdentifierSchema,
  R as metadataLabelRelationSchema,
  L as metadataLinkSchema,
  T as metadataListSchema,
  z as metadataLongTextSchema,
  N as metadataNullSchema,
  E as metadataNumberSchema,
  s as metadataRelationSchema,
  i as metadataSchema,
  O as metadataStatusSchema,
  F as metadataTextValueSchema,
  f as mongoFilterSchema,
  te as pagePropsSchema,
  m as pdfBoundingBoxPositionSchema,
  D as pdfDocumentPropsSchema,
  ne as pdfFileSchema,
  se as pdfHighlightSchema,
  U as pdfOffsetPositionSchema,
  v as pdfPagePropsSchema,
  A as pdfPositionSchema,
  ye as productDocumentSchema,
  be as queueDocumentSchema,
  b as readableFileSchema,
  Ue as searchFilterSchema,
  qe as sendEmailVerificationEmailRequestSchema,
  Fe as sendEmailVerificationEmailResponseSchema,
  Pe as signupRequestSchema,
  Be as signupResponseSchema,
  Ie as signupTokenDocumentSchema,
  J as tocNodeSchema,
  Z as unreadableFileSchema,
  pe as updateQueueDocumentInputSchema,
  we as userDataSchema,
  S as userEditableSchema,
  De as userHiddenSchema,
  j as userReadableSchema,
  ze as verifyEmailRequestSchema,
  Ee as verifyEmailResponseSchema
};
//# sourceMappingURL=index.js.map
